import React, { useState, useEffect } from "react";
import { Header } from "../../../components/page-header/Header";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  useCreateUpdateJummahTimeMutation,
  useGetJummahtimeQuery,
} from "../../../store/Reducer/prayertimes";
import toast from "react-hot-toast";
const PrayerTimeJummah = () => {
  const { t } = useTranslation();

  const [jummahTimes, setJummahTimes] = useState([{ athan: "", iqamah: "" }]);

  const breadcrumbItems = [
    { label: t("universal_dashboard_text"), to: '/user-dashboard' },
    { label: t("prayerTimes_breadcrumb_title"), to: "/user-dashboard/prayer-times/main" },
    { label: t("jummah_breadcrumb_title") },
  ];

  const [createUpdateJummahTime, { isLoading: saving }] =
    useCreateUpdateJummahTimeMutation();
  const {
    data: fetchedJummahTimes,
    isLoading: fetching,
    error,
    refetch,
  } = useGetJummahtimeQuery();

  const maxJummah = 15;
  const minJummah = 1;
  const convertTo24HourFormat = (time12h) => {
    if (!time12h) return ""; // If time is missing, return an empty string
    const [time, modifier] = time12h.split(" ");
    let [hours, minutes] = time.split(":");

    if (modifier === "PM" && hours !== "12") {
      hours = String(parseInt(hours, 10) + 12);
    } else if (modifier === "AM" && hours === "12") {
      hours = "00";
    }

    return `${hours.padStart(2, "0")}:${minutes}`; // Return HH:mm format
  };



  // Pre-fill jummah times from query data
  useEffect(() => {
    if (fetchedJummahTimes?.data && Array.isArray(fetchedJummahTimes.data)) {
      console.log("Fetched Data:", fetchedJummahTimes.data);

      const formattedTimes = fetchedJummahTimes.data.map((item) => ({
        athan: convertTo24HourFormat(item.athanTime),
        iqamah: convertTo24HourFormat(item.iqamahTime),
      }));

      console.log("Formatted Times:", formattedTimes);

      if (formattedTimes.length > 0) {
        setJummahTimes(formattedTimes); // Only update if data is available
      }
    }
  }, [fetchedJummahTimes]);
  useEffect(() => {
    refetch()
  }, [])





  const handleAddJummah = () => {
    if (jummahTimes.length < maxJummah) {
      setJummahTimes([...jummahTimes, { athan: "", iqamah: "" }]);
    }
  };

  const handleRemoveJummah = (index) => {
    if (jummahTimes.length > minJummah) {
      setJummahTimes(jummahTimes.filter((_, i) => i !== index));
    }
  };

  const handleChange = (index, field, value) => {
    const updatedJummahTimes = [...jummahTimes];
    updatedJummahTimes[index][field] = value;
    setJummahTimes(updatedJummahTimes);
  };

  const handleSaveChanges = async () => {
    try {
      await createUpdateJummahTime(
        jummahTimes.map((item) => ({
          athanTime: item.athan,
          iqamahTime: item.iqamah,
        }))
      ).unwrap();
      toast.success("Jummah times updated successfully!");
    } catch (error) {
      toast.error(
        `Failed to update Jummah times: ${error?.data?.message || error.message
        }`
      );
    }
  };


  return (
    <section className="min-h-screen bg-gradient-to-b from-slate-50 to-gray-50 font-sans">
      <div className="max-w-7xl mx-auto p-6">
        <div className="space-y-6">
          <div className="flex items-center justify-between">
            <Header title={t("prayer_time_settings_text")} breadcrumbItems={breadcrumbItems} />
          </div>

          <div className="content grid gap-6 md:grid-cols-2">
            <div className="bg-white p-6 rounded-xl shadow-md">
              <h2 className="text-xl font-semibold mb-4">{t("jummah_setting_title")}</h2>
              {fetching ? (
                <p>Loading Jummah times...</p>
              ) : (
                <div className="space-y-4">
                  {jummahTimes?.map((jummah, index) => (
                    <div
                      key={index}
                      className="space-y-2 border-b border-gray-200 pb-4 mb-4"
                    >
                      <label
                        htmlFor={`Jummah${index + 1}`}
                        className="block text-sm font-medium text-gray-700"
                      >
                        Jummah {index + 1}
                      </label>
                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <label className="block text-sm font-medium text-gray-700">
                            Athan time
                          </label>
                          <input
                            type="time"
                            name={`athan${index}`}
                            value={jummahTimes[index]?.athan || ""}
                            onChange={(e) => handleChange(index, "athan", e.target.value)}
                            className="mt-1 block p-3 w-full border border-gray-300 rounded-md shadow-sm text-sm"
                            required
                          />

                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700">
                            Iqamah time
                          </label>
                          <input
                            type="time"
                            name={`iqamah${index}`}
                            value={jummahTimes[index]?.iqamah || ""}
                            onChange={(e) => handleChange(index, "iqamah", e.target.value)}
                            className="mt-1 block p-3 w-full border border-gray-300 rounded-md shadow-sm text-sm"
                            required
                          />
                        </div>
                      </div>
                      <div className="flex justify-end mt-2">
                        {jummahTimes.length > minJummah && (
                          <button
                            onClick={() => handleRemoveJummah(index)}
                            className="text-red-600 hover:text-red-800 text-sm"
                          >
                            Remove
                          </button>
                        )}
                      </div>
                    </div>
                  ))}

                  {jummahTimes?.length < maxJummah && (
                    <button
                      onClick={handleAddJummah}
                      className="w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-blue-600 bg-blue-100 hover:bg-blue-200"
                    >
                      {t("jummah_add_another_btn_text")}
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>

          <div className="mt-6 flex justify-end items-center">
            <button
              onClick={handleSaveChanges}
              className="py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700"
              disabled={saving}
            >
              {saving ? t("universal_saving_text") : t("universal_save_changes_text")}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrayerTimeJummah;
